import { environment } from '../../../environments/environment';
import type {
  DataBuilderCancelPostBody,
  DataBuilderCancelPostResponse,
  DataBuilderEstimatePostBody,
  DataBuilderEstimatePostResponse,
  DataBuilderRootGetResponse,
  DataBuilderStatusGetResponse,
  DataBuilderSubmitPostBody,
  DataBuilderSubmitPostResponse,
  DataBuilderVerifyPostBody,
  DataBuilderVerifyPostResponse,
} from './data-builder-api.types';
import { fetchJson } from './fetch-util';

const BASE_URL = `${environment.GO_API_ROOT}/proxy/deliverables`;

export const fetchDataBuilderResults =
  (): Promise<DataBuilderRootGetResponse> =>
    fetchJson<DataBuilderRootGetResponse>(BASE_URL + '/', {
      method: 'GET',
    });

export const fetchDataBuilderStatus = (
  userId?: string
): Promise<DataBuilderStatusGetResponse> => {
  const url = userId
    ? `${BASE_URL}/status?user_id=${encodeURIComponent(userId)}`
    : `${BASE_URL}/status`;
  return fetchJson<DataBuilderStatusGetResponse>(url, {
    method: 'GET',
  });
};

// When wrapping in useMutation, decorate the options with
// withDataBuilderMutationPolicy so the 422-skip + Kibana logging policy
// stays attached.
export const verifyDataBuilderPayload = (
  payload: DataBuilderVerifyPostBody
): Promise<DataBuilderVerifyPostResponse> =>
  fetchJson<DataBuilderVerifyPostResponse>(`${BASE_URL}/verify`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const submitDataBuilderPayload = (
  payload: DataBuilderSubmitPostBody
): Promise<DataBuilderSubmitPostResponse> =>
  fetchJson<DataBuilderSubmitPostResponse>(`${BASE_URL}/submit`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const estimateDataBuilderPayload = (
  payload: DataBuilderEstimatePostBody
): Promise<DataBuilderEstimatePostResponse> =>
  fetchJson<DataBuilderEstimatePostResponse>(`${BASE_URL}/estimate`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const cancelDataBuilderRun = (
  body: DataBuilderCancelPostBody
): Promise<DataBuilderCancelPostResponse> =>
  fetchJson<DataBuilderCancelPostResponse>(`${BASE_URL}/cancel`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
